module.exports = __webpack_public_path__ + "d11ea2a21726dcb42098df2d0a8e8c05.MP3";